export default "__VITE_ASSET__572a4a25__"